<template>
  <vs-popup id="table-list-page-info-popup" :title="data.title" :active.sync="showPopup">
    <div v-html="data.html"></div>
  </vs-popup>
</template>

<script>
export default {
  props: {
    data: Object,
    value: Boolean,
  },
  watch: {
    value(data) {
      this.showPopup = data;
    },
    showPopup(data) {
      this.$emit("input", data);
    },
  },
  data() {
    return {
      showPopup: this.value,
    };
  },
  mounted() {
    const popupboardContainer = document.getElementById("Popupboard-Container");
    if (popupboardContainer) document.body.insertBefore(popupboardContainer, document.body.firstChild);
  },
};
</script>

<style lang="scss" scoped>
#table-list-page-info-popup::v-deep .vs-popup {
  width: 380px;
}
</style>
